import React from 'react';
import { Grid, GridItem, Box, Container } from '@chakra-ui/react';
import { RichText } from '../RichText';

function Columns({ data }) {
  const { columns, title, subTitle, masonryGrid } = data || {};
  return (
    <Box>
      {title && (
        <Container
          as='header'
          maxWidth='container.md'
          px={{ base: 0, xl: 50 }}
          textAlign='center'
          mb={{ base: 30, xl: 40 }}
        >
          <RichText value={title} as='h2' textStyle='h2' />
          {subTitle && <RichText value={subTitle} />}
        </Container>
      )}
      <Box
        as={masonryGrid ? 'div' : Grid}
        templateColumns={masonryGrid ? null : { base: 'repeat(1, 1fr)', lg: 'repeat(3, 1fr)' }}
        columnGap={30}
        rowGap={{ base: 30, xl: 50 }}
        px={{ base: 30, xl: 80 }}
        sx={masonryGrid ? { columnCount: [1, 2, 3], columnGap: 60 } : null}
      >
        {columns?.map((column) => (
          <Box
            as={masonryGrid ? 'div' : GridItem}
            key={column._key}
            marginBottom={{ base: 30, lg: 50 }}
            sx={masonryGrid ? { breakInside: 'avoid-column' } : null}
          >
            {column.content && <RichText value={column.content} textStyle='body' />}
          </Box>
        ))}
      </Box>
    </Box>
  );
}

export default Columns;
